module.exports = __webpack_public_path__ + "img/S9015-IL.a3cc6b41.jpg";